import {  useEffect, useState } from "react";
import { CopyIcon,UnlockIcon } from "@chakra-ui/icons";
import { FcSurvey } from "react-icons/fc";
import { Text, TableContainer, Tr, Td, Th, Table, Thead, Tbody, Icon, Heading, Box, useToast, Tooltip, Button,
  Modal ,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,Input

} from "@chakra-ui/react";
import { getSurveyAnswerStatusADP } from "../../services/http/surveyHttpService";
import { EditIcon,ViewIcon } from "@chakra-ui/icons";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";
import {  useSession } from "../../SessionContext";
import {  useNavigate} from "react-router-dom";
import logout from "../../services/authService";
import { RiAddLargeFill } from "react-icons/ri";
import { cloneSurveyADP, getSurveyCatalogueADP, initSurveyService, openSurveyADP } from "../../services/http/surveyHttpService";
import { useTranslation } from "react-i18next";
import SurveyPreviewModal from "./SurveyPreviewModal";
import { getSurveyADP } from "../../services/http/surveyHttpService";
import { useDisclosure } from "@chakra-ui/react";
import { useExchangeData } from "./groups/ExchangeDataProvider";
import SurveyAnswerStatusModal from "./SurveyAnswerStatusModal";
export default function SurveyConsensusView (){
  const { isOpen: isOpenModalConfirmDeleteSurvey, onOpen: onOpenModalConfirmDeleteSurvey, onClose: onCloseModalConfirmDeleteSurvey } = useDisclosure();
  const { isOpen: isOpenModalConfirmOpenSurvey, onOpen: onOpenModalConfirmOpenSurvey, onClose: onCloseModalConfirmOpenSurvey } = useDisclosure();

  const [dataAnswerStatusSurvey, setDataAnswerStatusSurvey] = useState({})

  const {t} = useTranslation();

    const {setUpdateDataSurvey } = useExchangeData();
  

  const [surveys, setSurveys] = useState([]);
  const [survey, setSurvey] = useState({});
  const [surveyId, setSurveyId] = useState({});


  const toast = useToast();
  const [message, setMessage] = useState("");
  const { updateSessionData, clearSessionData} = useSession();

  const navigate = useNavigate();
  const [isModalPreviewOpen, setModalPreviewOpen] = useState(false)
  const [payloadCloneSurvey, setPayloadCloneSurvey] = useState({})


  const { isOpen: isUploadModalOpen, onOpen: onUploadModalOpen, onClose: onUploadModalClose } = useDisclosure();
  
  const { isOpen: isAnswerStatusModalOpen, onOpen: onAnswerStatusOpen, onClose: onAnswerStatusClose } = useDisclosure();

  const [payloadUploadDashboard, setPayloadUploadDashboard] = useState({});

  const axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(t, clearSessionData,navigate,toast,axiosInstance)
  });

  initSurveyService(t, toast, axiosInstance)
  /*
  Carica le dashboards in una tabella ogni volta che viene caricata la pagina (useEffect) interrogando l'endpoint con 
  l'invio di un json contente il token di identificaione, l'username dellutente e una costante caseType per indicare al backend 
  di quale chiamata si tratta e quali paremetri deve inviarci. Per consultare i case type consultare il file CaseTypeConstant.js  
  */
  useEffect(() => {
    populateSurveyCatalogue()


},[]);

const populateSurveyCatalogue = () => {
  getSurveyCatalogueADP({username: sessionStorage.getItem("username"), is_consensus: true, status: "draft"}).then(res => {
    if(res != null && res.survey_catalogue != null && res.survey_catalogue.length >0)
    setSurveys(res.survey_catalogue)
  })
}
  
const handleChangePayloadUploadDashboard = (e, field) => {
  const value = e.target ? e.target.value : e;
 

  setPayloadUploadDashboard((prev) => ({
    ...prev,
    [field]: value,
  }));
};

const [searchCheckedCategories, setSearchCheckedCategories] = useState(
  [])



  const handleCategoryChange = (category) => {
    setSearchCheckedCategories((prevCategories) => {
      // Controlla se la categoria è già selezionata
      const isCategoryChecked = prevCategories.includes(category);
  
      // Se è già selezionata, la rimuoviamo; altrimenti, la aggiungiamo
      const updatedCategories = isCategoryChecked
        ? prevCategories.filter((c) => c !== category)  // Rimuovi la categoria
        : [...prevCategories, category];  // Aggiungi la categoria
  
      // Aggiorna il payload con le categorie modificate
      setPayloadUploadDashboard((prev) => ({
        ...prev,
        categories: updatedCategories,  // Usa le categorie aggiornate
      }));
  
      return updatedCategories;  // Ritorna l'array aggiornato
    });
  };




      const submitDashboard = async () => {
        if(payloadUploadDashboard.dashboardName != null && payloadUploadDashboard.dashboardName.length >0 &&
          payloadUploadDashboard.linkDashboard != null && payloadUploadDashboard.linkDashboard.length >0 &&
          
          payloadUploadDashboard.visibility != null && payloadUploadDashboard.categories.length > 0 &&
          payloadUploadDashboard.description != null && payloadUploadDashboard.description.length >0
        ) {
        try{
         
           }

      
      catch(error) {
        toast({
          title: t('toastMsg.error'),
          description: String(error),
          position: "top",
          status: 'warning',
          duration: 4000,
          isClosable: true});
    }



  }
      


      }
      
      const [openDashboardModal, setOpenDashboardModal] = useState(false);
      const [linkDashboard, setLinkDashboard] = useState("")

      const onCloseDashboardViewModal = () => {
        setOpenDashboardModal(false)
      }

      /*const openDashboardViewModal = (link) => {
      setLinkDashboard(link)
      setOpenDashboardModal(true)
      }*/

      const openDashboardViewModal = (link) => {
        //const encodedLink = encodeURIComponent(link);
        navigate('/iframe', { state: { link } });
        }


      
    return(
        <>



      <SurveyPreviewModal
       isConsensus={true}
        surveyConfig={survey} // Passa la configurazione del sondaggio
        isOpen={isModalPreviewOpen} // Stato di apertura/chiusura
        onClose={()=> setModalPreviewOpen(false)} // Funzione per chiudere
      />






<Modal onClose={onCloseModalConfirmDeleteSurvey} isOpen={isOpenModalConfirmDeleteSurvey} isCentered closeOnOverlayClick={false} >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>   {t('survey.tableExpert.doYouConfirmToRemoveTheExpert')} </ModalHeader>
              <ModalBody></ModalBody>
              <ModalFooter>
                <Button colorScheme='green' mr={3} onClick={()=> {
                  
                 
                }}>
                   {t('survey.tableGroup.yes')}
                </Button>
                <Button colorScheme='red' onClick={onCloseModalConfirmDeleteSurvey}>
                  No
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>



          <Modal onClose={onCloseModalConfirmOpenSurvey} isOpen={isOpenModalConfirmOpenSurvey} isCentered closeOnOverlayClick={false} >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>   {t('survey.tableSurveys.doYouConfirmToOpenTheSurvey')} </ModalHeader>
              <ModalBody></ModalBody>
              <ModalFooter>
                <Button colorScheme='green' mr={3} onClick={()=> {

                  openSurveyADP(surveyId)
         
                  .then(res => {
                    populateSurveyCatalogue()
                    onCloseModalConfirmOpenSurvey();
                  }
                ).catch(e=> {
                  console.log(e)
                })
          
                 
                }}>
                   {t('survey.tableGroup.yes')}
                </Button>
                <Button colorScheme='red' onClick={onCloseModalConfirmOpenSurvey}>
                  No
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>



         
          <SurveyAnswerStatusModal
            isOpen={isAnswerStatusModalOpen}
            onClose={onAnswerStatusClose}
            dataAnswerStatusSurvey={dataAnswerStatusSurvey}
          ></SurveyAnswerStatusModal>


        

      

        <Box alignItems={"center"} justifyContent={"space-between"} display={"flex"} color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"}>
          <Heading>{t('survey.consensusSurveys')}</Heading>
          <Tooltip label={t('toolTip.tooltipSurvey.consensusSurveys.header')} placement="left">
          <Button  color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"} h={"100%"} onClick={()=> {onUploadModalOpen(); navigate("/survey-consensus-create?hideHeader=true&hideNavbar=true")}}>
            <Icon boxSize={4} mr={1} strokeWidth={1} as={RiAddLargeFill}/>{t('survey.createSurveyConsensus')}
            </Button>
          </Tooltip>
            </Box>
        <Box bgColor={"white"}   overflowY="auto" direction="column" h="100%" w="100%" boxShadow="lg">
        <TableContainer px={"1%"} paddingTop={"1%"} >
        
        <Table variant='striped' >
    
        <Thead bgColor="#0888BE">
      <Tr>
      <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="15%" color="white">
          Id Survey
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="15%" color="white">
          {t('survey.tableSurveys.title')}
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="15%" color="white">
          {t('survey.tableSurveys.owner')}
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="120px" w="20%" color="white">
          {t('survey.tableSurveys.creationDate')}
        </Th>
     
        <Th whiteSpace="normal" wordBreak="break-word" minW="120px" w="10%" color="white">
          {t('survey.tableSurveys.type')}
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="200px" w="40%" color="white">
          {t('survey.tableSurveys.description')}
        </Th>
    
     
        <Th color="white" minW="200px" textAlign="center">{t('survey.tableSurveys.actions')}</Th>
      </Tr>
    </Thead>
     
      <Tbody  maxHeight="100%" overflowY="auto" borderWidth={1} boxShadow="lg">
      {surveys.length > 0 ? 
      
    (surveys.map(item=> (


    <Tr>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}> {item.id_survey_info}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}> {item.title}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.owner}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.creation_date}</Td>
    

      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.type}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.description}</Td>
 
      <Td textAlign="center" whiteSpace={"normal"} wordBreak={"break-word"}>

        




      


<Tooltip label={t('toolTip.tooltipSurvey.consensusSurveys.tableActions.surveyPreview')} placement="bottom">
    <Icon ml={"10%"}
      as={ViewIcon} // Sostituisci con l'icona corretta per aggiornare
      onClick={() =>{

       

        getSurveyADP({id_survey_info: item.id_survey_info }).then(res => {
        

          if(res && res.message && res.message.survey_structure)  {

            setSurvey(res.message.survey_structure)

            setModalPreviewOpen(true)
            
          }
  
        })

      }}
      _hover={{ color: "blue.200" }}
      cursor="pointer"
    />
  </Tooltip>


  <Tooltip label={t('toolTip.tooltipSurvey.surveys.tableActions.viewAnswerStatus')} placement="bottom">
    <span>
  <Icon
    ml={"10%"}
    mb={"-8px"}
    as={FcSurvey} // Sostituisci con l'icona corretta per aggiornare
    onClick={() => {
      getSurveyAnswerStatusADP(t, item.id_survey_info).then(res => {
        console.log(res)

        setDataAnswerStatusSurvey(res)

        onAnswerStatusOpen()
      })
    }}
    _hover={{ color: "blue.200" }}
    cursor="pointer"
  />
</span>
</Tooltip>



  {item.status === "draft" && item.owner === sessionStorage.getItem("username") && (
<Tooltip label={t('toolTip.tooltipSurvey.consensusSurveys.tableActions.updateSurvey')} placement="bottom">
    <Icon ml={"10%"}
      as={EditIcon} // Sostituisci con l'icona corretta per aggiornare
      onClick={() =>{


        setUpdateDataSurvey(item)

        navigate(`/survey-consensus-update/${item.id_survey_info}?hideHeader=true&hideNavbar=true`);

      }}
      _hover={{ color: "blue.200" }}
      cursor="pointer"
    />
  </Tooltip>
)}


{item.status === "created" && item.owner === sessionStorage.getItem("username") && (
<Tooltip label={t('toolTip.tooltipSurvey.consensusSurveys.tableActions.openToPublic')} placement="bottom">
    <Icon ml={"10%"}
      as={UnlockIcon} // Sostituisci con l'icona corretta per aggiornare
      onClick={() =>{


        setSurveyId(item.id_survey_info)

        onOpenModalConfirmOpenSurvey()

       
      }}
      _hover={{ color: "blue.200" }}
      cursor="pointer"
    />
  </Tooltip>
)}

 

      </Td>
    </Tr>))): (<Tr><Text fontSize={"lg"} fontWeight={"bold"}>{message}</Text></Tr>)}

      </Tbody>
      
     
    </Table> 
  </TableContainer>
  </Box> 



                            </>



    )


}






